import './App.css';
import { useState ,useEffect } from 'react';
import Form from './Form';



function App() {
  // const [IPInfos, setIPInfos] = useState({})
  // const getHandler = (obj) =>{
  //   setIPInfos(obj)
  //   console.log(obj)
  // }    
  return (
    <div className="app">
       <Form    />
       
    </div>
  );
}

export default App;
